import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { ACCOUNT_SETTINGS_PAGES } from '../../routing/routeConfiguration';
import { isTrailerRenter } from '../../util/genericHelpers';
import { LinkTabNavHorizontal } from '../../components';

import css from './UserNav.module.css';

const UserNav = props => {
  const { className, rootClassName, currentPage, currentUser } = props;
  const classes = classNames(rootClassName || css.root, className);

  // Confirmed renters should not see owner-only surfaces (PL2). "Your Listings"
  // is owner-only. Safe default: only EXPLICITLY-tagged renters get it hidden;
  // owners / untagged / junk-tagged keep the full owner nav.
  const hideYourListings = isTrailerRenter(currentUser);

  // NOTE: filter the tab array (never inline `null` into a rendered children
  // list) so we don't risk the MenuContent/child-validator freeze pattern.
  // Owner Dashboard is the first owner-only surface (same visibility rule as
  // Your Listings — hidden from explicitly-tagged renters, visible to all
  // owners / untagged users). Must be FIRST in the tab list.
  const ownerDashboardTab = hideYourListings
    ? []
    : [
        {
          text: <FormattedMessage id="UserNav.ownerDashboard" />,
          selected: currentPage === 'UserDashboardPage',
          linkProps: {
            name: 'UserDashboardPage',
          },
        },
      ];

  const yourListingsTab = hideYourListings
    ? []
    : [
        {
          text: <FormattedMessage id="UserNav.yourListings" />,
          selected: currentPage === 'ManageListingsPage',
          linkProps: {
            name: 'ManageListingsPage',
          },
        },
      ];

  // Owner Toolbox is an owner-only surface (same visibility rule as Your
  // Listings): hidden from explicitly-tagged renters, shown to everyone else.
  const toolboxTab = hideYourListings
    ? []
    : [
        {
          text: <FormattedMessage id="UserNav.toolbox" />,
          selected: currentPage === 'ToolboxIndexPage',
          linkProps: {
            name: 'ToolboxIndexPage',
          },
        },
      ];

  const tabs = [
    ...ownerDashboardTab,
    ...yourListingsTab,
    ...toolboxTab,
    {
      text: <FormattedMessage id="UserNav.profileSettings" />,
      selected: currentPage === 'ProfileSettingsPage',
      disabled: false,
      linkProps: {
        name: 'ProfileSettingsPage',
      },
    },
    {
      text: <FormattedMessage id="UserNav.accountSettings" />,
      selected: ACCOUNT_SETTINGS_PAGES.includes(currentPage),
      disabled: false,
      linkProps: {
        name: 'ContactDetailsPage',
      },
    },
  ];

  return (
    <LinkTabNavHorizontal className={classes} tabRootClassName={css.tab} tabs={tabs} skin="dark" />
  );
};

UserNav.defaultProps = {
  className: null,
  rootClassName: null,
  currentUser: null,
};

const { string, object } = PropTypes;

UserNav.propTypes = {
  className: string,
  rootClassName: string,
  currentPage: string.isRequired,
  currentUser: object,
};

export default UserNav;
